// extracted by mini-css-extract-plugin
export var closeButton = "_2j-3";
export var header = "_2j-0";
export var link = "_2j-1";
export var retryButton = "_2j-2";